import React, { Component } from 'react';
import TablePagination from '@material-ui/core/TablePagination'
import { inject, observer } from 'mobx-react'


@inject('RevenueReportStore')
@observer
class RevenuePagination extends Component {

  handlePageChange = (e, page) => {
    console.log(page)
    this.props.RevenueReportStore.handlePageChange(page)
  }

  handleChangeRowsPerPage = (e) => {
    this.props.RevenueReportStore.handleChangeRowsPerPage(e.target.value)
  }

  render() {

    const { count, page, limit } = this.props.RevenueReportStore

    return (
      <div>
        <TablePagination
          rowsPerPageOptions={[15, 30, 100]}
          component="div"
          count={count}
          rowsPerPage={limit}
          page={page}
          onChangePage={this.handlePageChange}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </div>
    );
  }
}

export default RevenuePagination;